const getStatementCurrency = (statement, defaultCurrency) => {
    return statement?.Transaction?.Currency || statement?.Currency || defaultCurrency;
};

export const resolveSelectedCurrencyFromStatements = (statements, defaultCurrency) => {
    if (!statements || statements.length === 0) {
        return defaultCurrency;
    }

    let allValuesAreConverted = true;
    const currencySet = new Set();

    for (const statement of statements) {
        currencySet.add(getStatementCurrency(statement, defaultCurrency));
        if (statement.ExchangeRate === 0) {
            allValuesAreConverted = false;
        }
    }

    if (allValuesAreConverted) {
        return defaultCurrency;
    }

    return [...currencySet][0] || defaultCurrency;
};

export const hasMixedCurrenciesForInvoice = (statements, defaultCurrency) => {
    if (!statements || statements.length === 0) {
        return false;
    }

    let allValuesAreConverted = true;
    let someValuesAreConverted = false;
    const currencySet = new Set();

    for (const statement of statements) {
        if (statement.ExchangeRate === 0) {
            allValuesAreConverted = false;
        } else {
            someValuesAreConverted = true;
        }
        currencySet.add(getStatementCurrency(statement, defaultCurrency));
    }

    if (allValuesAreConverted) {
        return false;
    }

    if (currencySet.size > 1) {
        return true;
    }

    const selectedCurrency = [...currencySet][0];
    return selectedCurrency !== defaultCurrency && someValuesAreConverted && !allValuesAreConverted;
};

export const getUniqueBillingInfoIds = (statements) => {
    return [...new Set((statements || []).map((statement) => statement.BillingInfoID).filter(Boolean))];
};
